const NON_PROD_ENVS = ['local', 'dev', 'test'];

export const isNonProd = (env?: string): boolean => {
  const currentEnv = env ?? import.meta.env.VITE_ENV;
  return NON_PROD_ENVS.includes(currentEnv);
};
